// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper[data-v-a47c5640] {\n  padding: 0.42667rem 0;\n}\n.swiper-item[data-v-a47c5640] {\n  border-radius: 0.26667rem;\n  width: 8rem;\n  height: 4.69333rem;\n  overflow: hidden;\n}\n.swiper-item .item-img[data-v-a47c5640] {\n  width: 8rem;\n  height: 4.69333rem;\n}\n.swiper-slide[data-v-a47c5640] {\n  width: 80%;\n}\n.swiper-slide[data-v-a47c5640]:nth-child(2n) {\n  width: 80%;\n}\n.swiper-slide[data-v-a47c5640]:nth-child(3n) {\n  width: 80%;\n}\n", ""]);
// Exports
module.exports = exports;
